import { Injectable, inject } from '@angular/core'
import { MatomoRouteInterceptorBase } from 'ngx-matomo-client'
import { ActivatedRouteSnapshot } from '@angular/router'
import { AnalyticsService } from '../../shared/service/analytics.service'

@Injectable()
export class TrackDataInterceptor extends MatomoRouteInterceptorBase<string> {
  private readonly analyticsService = inject(AnalyticsService)

  protected extractRouteData(route: ActivatedRouteSnapshot): string {
    return route.data?.analytics?.title ?? this.router.url
  }

  protected async processRouteData(pageTitle: string): Promise<void> {
    if (pageTitle) {
      await this.analyticsService.sendVisitAnalytics(pageTitle)
    }
  }
}
